<template>
    <div class="no-result">
      <dl class="empty_content">
        <dt>
          <img src="https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/icon-empty-content@2x2.png" alt="" />
        </dt>
        <dd>
          <p class="no-result-text">{{title}}</p>
        </dd>
      </dl>
    </div>
  </template>
  <script>
  export default {
    props: {
      title: {
        type: String,
        default: ""
      },
      iconClass: {
        type: String,
        default: ""
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  .no-result {
    text-align: center;
    position: relative;
  }
  
  .empty_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #F4F5F7;
    padding-bottom: 100px;
  
    > dt {
      width: 112px;
      height: 89px;
      margin-top: 50px;
  
      > img {
        width: 100%;
        height: 100%;
      }
    }
  
    > dd {
      margin-top: 6px;
      font-size: 13px;
      color: #AFAFB0;
    }
  }
  </style>
  